var objectProto = Object.prototype;
var isPrototype = function (value) {
    var Ctor = value && value.constructor;
    var proto = (typeof Ctor === 'function' && Ctor.prototype) || objectProto;
    return value === proto;
};
export default isPrototype;
//# sourceMappingURL=is-prototype.js.map


//////////////////
// WEBPACK FOOTER
// ./~/@antv/util/esm/is-prototype.js
// module id = 150
// module chunks = 3